import defaultPsychologistImage from '@avanta/shared/assets/avatar.svg';
import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import type { Appointment } from 'types/appointments';

interface PsychologistInfoProps {
  appointment: Appointment;
}

export const PsychologistInfo = ({ appointment }: PsychologistInfoProps): React.ReactElement => {
  const psychologist = appointment.psychologist?.psychologist;
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const fullName = [psychologist?.name, psychologist?.surname].filter(Boolean).join(' ');

  return (
    <div className="flex w-full max-w-102 gap-4 border-l-2 border-teal-300 px-4 py-4 bg-plum-100 rounded-r-xl shrink-0">
      <img
        className="size-24 shrink-0 rounded-full object-cover"
        src={psychologist?.imageSquare || defaultPsychologistImage}
        alt={fullName}
      />
      <div className="flex min-w-0 flex-col">
        <Text variant="text-xs-medium" className="text-denim-800 mb-2">
          {t('AppointmentCard.psychologist.label')}
        </Text>
        <Text variant="text-md-medium" className="text-denim-800 truncate">
          {fullName}
        </Text>
        {psychologist?.professionalNumber && (
          <Text variant="text-xs-medium" className="text-gray-400">
            {t('AppointmentsReserve.PsychoCard.professionalNumber', {
              professionalNumber: psychologist.professionalNumber,
            })}
          </Text>
        )}
      </div>
    </div>
  );
};
